<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 clientStaffTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="supplier_staff"
                        arrows >
                    <template slot="gofixTab:supplier_staff">
                        <gofix-card class="mb-0" fullContent>
                            <gofix-default-table :settings="tableConfig"
                                    :table-items="tableItems"
                                    @load-items="getTableData"
                                    @new-item="openCreateItem"
                                    @row-click="openCreateItem"
                                    @delete-items="deleteItems"
                                    ref="gofixTable">
                                <template slot="gofix_table:active" slot-scope="row">
                                    <span class="text-highlight">{{ row.item.active ? "Active" : "Inactive" }}</span>
                                </template>
                            </gofix-default-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
                 id="modal-Create"
                 :title="modals.create.title" hide-footer :centered="true"
                 v-model="modals.create.open">
            <b-form class="pb-20">
                <b-row>
                    <!-- <b-col md="12" v-if="isContractProject && !modals.create.data.id"> -->
                    <b-col md="12" v-if="!modals.create.data.id">
                        <div class="d-flex">
                            <b-form-checkbox v-model="modals.create.is_allow_roles" class="checkbox-main-allow">
                                <span>Allow user fm officer</span>
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Select by Name or Email"
                                vLabel="name"
                                desc="Search by name or email"
                                @search="searchUser"
                                @change="selectUser"
                                :filterable="false"
                                :options="modals.create.users.data"
                                :disabled="!!modals.create.data.id"
                                v-model="modals.create.data.user_id">
                            <template #gofixInput:dropdown:option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                            <template #gofixInput:dropdown:selected-option="{ name, email }">
                                {{name}} - {{email}}
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Role"
                                vLabel="name"
                                :filterable="false"
                                :multiple="!modals.create.data.id"
                                :required="true"
                                :reduce="option => option.id"
                                v-model="modals.create.data.role_id"
                                :options="modals.create.roles">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-properties
                                label="Property"
                                :contract-id="$route.params.id"
                                :property-id="SContract ? SContract.property_root_id : null"
                                :supplier-contract-id="$route.params.id"
                                v-model="modals.create.data.property"
                                valueFormat="object"
                                required>
                        </gofix-form-properties>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-tree
                            label="Service Category"
                            :default-expand-level="1"
                            :multiple="false"
                            :options="modals.create.service_categorys"
                            :load-options="loadOptionServices"
                            :normalizer="normalizer"
                            search-nested
                            valueFormat="object"
                            v-model="modals.create.data.service_category"
                            placeholder="Select"
                            ref="input">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="modals.create.data.start_date"
                                label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                                v-model="modals.create.data.end_date"
                                label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        name: 'contract-supplier-staff',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['contract_user_duty']));
            return {
                contract_tab:tabData.supplier_contract,
                activeClass: false,
                tableConfig:{
                    name: 'supplier-contract-supplier-staff',
                    controls:{},
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "user_id",
                    sortDirection: "asc",
                },
                tableItems: [],
                modals:{
                    create:{
                        open: false,
                        loading: false,
                        title:"Create new Supplier staff",
                        data:{
                            id: null,
                            user_id: null,
                            service_category_id: null,
                            service_category: null,
                            start_date: null,
                            end_date: null,
                            contract_id: this.$route.params.id,
                            property_id: null,
                            property: null,
                            role_id: null,
                            type: "Supplier",
                        },
                        users:{
                            data:[],
                            timer: null
                        },
                        properties:[],
                        roles:[],
                        service_categorys: [],
                        is_allow_roles: false
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                SContract: 'ContractController/SContract',
                ClientContractID: 'ContractController/ClientContractID',
            }),
            isContractProject() {
                if(this.SContract && this.SContract.contract_terms && this.SContract.contract_terms.length) {
                    let obj = this.SContract.contract_terms.filter(item => item.term_type == 'project');
                    if(obj.length) return true;
                }
                return false;
            },
        },
        watch: {
            SContract: function (val, old) {
                this.getUsers();
            },
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
            "modals.create.is_allow_roles": function(val) {
                if(!this.modals.create.data.id) {
                    this.modals.create.data.user_id = null;
                    this.selectUser(null);
                    this.getUsers();
                }
            }
        },
        created() {
            this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id);
            this.loadRootServiceCategory();
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                // if(!this.isContractProject)
                //     tableRequest.filter.user_type.value = 'Supplier';
                tableRequest.staff = true
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("UserDutyController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async getUsers(search = ''){
                let params = {page:1, totalPage : 0, limit:100, filters:{ name: search, organization_is_supplier: true, organisation_id:this.SContract ? this.SContract.supplier_id : 0, active: true, project_id: this.$route.params.id }}
                if(this.modals.create.is_allow_roles) {
                    params.allow_roles = ['Project Manager', 'Safety Officer', 'Safety Assessor']
                }
                await this.$store.dispatch("v2UserController/searchListUser", params)
                    .then(result=>{
                        this.modals.create.users.data = result.data
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            async openCreateItem(item){
                this.modals.create.is_allow_roles = false
                if(item){
                    this.modals.create.title = "update Supplier staff";
                    this.modals.create.data = {
                        id: item.id,
                        property_id:  item.property_id,
                        property: {
                            "id": item.property_id,
                            "name": item.property_name,
                            "text": item.property_name,
                            "data": {
                                "id": item.property_id,
                                "name": item.property_name,
                            },
                        },
                        contract_id: this.$route.params.id,
                        user_id: {
                            id: item.user_id,
                            name:item.user_name,
                            email:item.user_email,
                        },
                        role_id: item.role_id,
                        start_date: item.start_date ? moment(item.start_date).toDate() : null,
                        end_date: item.end_date ? moment(item.end_date).toDate() : null,
                        type: "Supplier",
                        service_category_id: item.service_category_id ? item.service_category_id : null,
                        service_category: item.service_category_id ? {
                            "id": item.service_category_id,
                            "name": item.service_category_name,
                            "text": item.service_category_name,
                            "data": {
                                "id": item.service_category_id,
                                "name": item.service_category_name,
                            },
                        } : null,
                    };

                    if(item.user_type == "FM Officer") this.modals.create.is_allow_roles = true
                    await this.getUsers()

                    this.modals.create.roles = [{
                        id: item.role_id,
                        name: item.role_name,
                    }];
                    for( let i = 0 ; i <  this.modals.create.users.data.length ; i++ ){
                        if(item.user_id === this.modals.create.users.data[i].id){
                            this.modals.create.roles = this.modals.create.users.data[i].roles;
                            if(item.user_type == "FM Officer") {
                                this.modals.create.roles = this.modals.create.roles.filter(item => ['Project Manager', 'Safety Officer', 'Safety Assessor'].includes(item.name))
                            }
                        }
                    }
                }else{
                    this.modals.create.title = "Create new Supplier staff";
                    this.modals.create.data = {
                        id: null,
                        user_id: null,
                        start_date: null,
                        end_date: null,
                        contract_id: this.$route.params.id,
                        property_id: null,
                        property: null,
                        role_id: null,
                        type: "Supplier",
                        service_category_id: null,
                        service_category: null,
                    };
                }

                this.modals.create.open = true;
            },
            searchUser (search, loading){
                loading(true);
                if(this.modals.create.users.timer) {
                    clearTimeout(this.modals.create.users.timer);
                    this.modals.create.users.timer = null;
                }

                this.modals.create.users.timer = setTimeout(async () => {
                    try {
                        await this.getUsers(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            selectUser(item){
                let roles = item && item.roles ? item.roles : [];
                if(item && item.is_fm_company) {
                    roles = roles.filter(item => ['Project Manager', 'Safety Officer', 'Safety Assessor'].includes(item.name))
                }

                this.modals.create.roles = roles;
                this.modals.create.data.role_id = roles.length ? roles.map(x => x.id) : null;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("UserDutyController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'supplier_staff'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveData() {
                if(!this.modals.create.data.user_id) return this.$alertNotification("Please select user", "danger");
                if(!this.modals.create.data.role_id) return this.$alertNotification("Please select a role", "danger");
                if(!this.modals.create.data.property) return this.$alertNotification("Please select a property", "danger");
                if(!this.modals.create.data.service_category) return this.$alertNotification("Please select a service category", "danger");

                if(this.modals.create.loading) return;
                let request = Object.assign({}, this.modals.create.data);
                this.modals.create.loading = true;
                request.user_id = this.modals.create.data.user_id ? this.modals.create.data.user_id.id : null;
                request.property_id = this.modals.create.data.property ? this.modals.create.data.property.id : null;
                request.start_date = this.modals.create.data.start_date ? moment(this.modals.create.data.start_date).format("YYYY-MM-DD") : null;
                request.end_date = this.modals.create.data.end_date ? moment(this.modals.create.data.end_date).format("YYYY-MM-DD") : null;
                request.service_category_id = request.service_category ? request.service_category.id : null;

                let action = 'createItem';
                let keyMsg = 'adding'
                if(this.modals.create.data.id){
                    action = 'updateItem';
                    keyMsg = 'editing'
                } 
                this.$store.dispatch(`UserDutyController/${action}`, request)
                    .then(result => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        //this.$notificationV2('custom', 'user_duty_assign')
                        this.$alertNotification(this.$notificationV2(keyMsg, 'supplier_staff'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                        if(error.response && error.response.data && error.response.data.error) {
                            return this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                    })
            },
            normalizer(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children,
                    };
                return {
                    id: node.data.id,
                    label: node.text,
                    children: undefined
                };
            },
            loadRootServiceCategory(){
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.$route.params.id,
                    categoryId: 0
                }).then(response => {
                    this.modals.create.service_categorys = response;
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.$route.params.id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }
            },
        }
    }
</script>
